var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg002Girl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464 464",
    style: {
      enableBackground: "new 0 0 464 464"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD7A3"
    },
    d: "M370.802,365.011c-1.752-13.142-9.902-24.561-21.761-30.49l-17.232-8.616 c-2.567-1.284-5.51-0.145-6.766,2.29L316.36,325c59.867-16.309,91.64-45,91.64-45c-31.5-61.5-23-155-48-208S288,0,232,0 S129,19,104,72S87.5,218.5,56,280c0,0,31.774,28.69,91.641,44.999l-8.682,3.195c-1.242-2.438-4.18-3.584-6.742-2.303l-15.714,7.857 c-13.41,6.705-21.552,18.121-23.304,31.262l-0.388,2.908c0,0.001,0,0.001,0,0.001l-9.188,68.908 C81.705,451.216,92.898,464,107.413,464h249.175c14.515,0,25.708-12.784,23.789-27.172L370.802,365.011z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D6E48"
    },
    d: "M360,72C335,19,288,0,232,0S129,19,104,72S87.5,218.5,56,280c0,0,62,56,176,56s176-56,176-56 C376.5,218.5,385,125,360,72z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D5F3D"
    },
    d: "M184,143c0-56,20.909-108.293,63.137-142.45C242.164,0.219,237.135,0,232,0c-56,0-103,19-128,72 S87.5,218.5,56,280c0,0,45.431,39.895,128,52.264C184,332.265,184,187,184,143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD7A3"
    },
    d: "M371.19,367.921c-1.962-14.712-11.908-27.128-25.837-32.253l-54.412-20.02 c-6.533-2.178-10.94-8.292-10.94-15.179V248h-96v52.468c0,6.887-4.407,13.001-10.94,15.179l-54.412,20.02 c-13.929,5.125-23.875,17.541-25.837,32.253l-9.188,68.908C81.706,451.216,92.899,464,107.413,464h249.176 c14.515,0,25.708-12.784,23.789-27.172L371.19,367.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC88E"
    },
    d: "M184,300.469c0,0.391-0.017,0.777-0.046,1.161c-0.014,0.2-0.04,0.396-0.062,0.595 c-0.018,0.16-0.034,0.32-0.057,0.478c-0.043,0.307-0.098,0.609-0.158,0.911c-0.001,0.006-0.002,0.013-0.004,0.019 c-0.888,4.4-3.587,8.228-7.424,10.538C243.173,325.732,280,274.667,280,274.667L184,274V300.469L184,300.469L184,300.469z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M344,160v-16c0-22.091-17.909-40-40-40H160c-22.091,0-40,17.909-40,40v16c-13.255,0-24,10.746-24,24 c0,13.255,10.745,24,24,24v8c0,19.377,11.651,36.854,29.538,44.308l51.691,21.538c9.75,4.063,20.208,6.154,30.77,6.154l0,0 c10.562,0,21.019-2.092,30.769-6.154l51.694-21.539C332.349,252.855,344,235.378,344,216v-8c13.255,0,24-10.745,24-24 S357.255,160,344,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD7A3"
    },
    d: "M302,127.625V107H144.811C130.255,112.981,120,127.288,120,144v16c-13.255,0-24,10.745-24,24 s10.745,24,24,24v8c0,19.378,11.651,36.855,29.538,44.308l51.69,21.538c2.53,1.054,5.112,1.962,7.727,2.749 c-22.844-16.711-38.05-31.32-46.96-40.872c-6.482-6.95-9.995-16.121-9.995-25.625v-58.21 C177.806,159.253,259.684,155.067,302,127.625z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M176,192L176,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8 C184,188.4,180.4,192,176,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623F33"
    },
    d: "M288,192L288,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8 C296,188.4,292.4,192,288,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B07B"
    },
    d: "M232,248.219c-14.223,0-27.527-3.5-36.5-9.605c-3.652-2.484-4.602-7.461-2.113-11.113 c2.48-3.648,7.461-4.598,11.113-2.113c6.289,4.277,16.57,6.832,27.5,6.832s21.211-2.555,27.5-6.832 c3.66-2.492,8.629-1.539,11.113,2.113c2.488,3.652,1.539,8.629-2.113,11.113C259.528,244.719,246.223,248.219,232,248.219z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D6E48"
    },
    d: "M136,144c0,0,51,5,80-8c4.081-1.829,16-28,16-28v36c0,0,36.786-1.903,75-17.326V98H130.55 C134.183,116.297,136,144,136,144z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6473"
    },
    d: "M349.041,334.521l-17.232-8.616c-2.92-1.46-6.327,0.212-7.184,3.362 c-11.09,40.761-48.352,70.736-92.626,70.736c-44.285,0-81.555-29.99-92.635-70.767c-0.852-3.134-4.242-4.797-7.146-3.345 l-15.714,7.857c-13.41,6.705-21.552,18.121-23.304,31.262l-9.576,71.817c-1.918,14.388,9.275,27.172,23.789,27.172h249.176 c14.515,0,25.708-12.784,23.789-27.172l-9.576-71.817C369.05,351.87,360.9,340.45,349.041,334.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F05467"
    },
    d: "M96.843,353.124c-1.813,3.734-3.087,7.708-3.645,11.887l-9.576,71.817 C81.704,451.216,92.897,464,107.412,464H144v-32c0-10.386-3.369-20.491-9.6-28.8L96.843,353.124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F05467"
    },
    d: "M367.157,353.124c1.813,3.734,3.087,7.708,3.645,11.887l9.576,71.817 c1.918,14.388-9.275,27.172-23.79,27.172H320v-32c0-10.386,3.368-20.491,9.6-28.8L367.157,353.124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD445A"
    },
    d: "M332,103.649c0,10.77-21.73,19.5-32.5,19.5s-19.5-8.73-19.5-19.5s8.73-19.5,19.5-19.5 S332,92.88,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD445A"
    },
    d: "M332,103.649c0-10.77,21.73-19.5,32.5-19.5s19.5,8.73,19.5,19.5s-8.73,19.5-19.5,19.5 S332,114.419,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6473"
    },
    d: "M332,103.649c9.327,5.385,6.022,28.569,0.638,37.896c-5.385,9.327-17.311,12.522-26.638,7.138 s-12.522-17.311-7.138-26.638C304.248,112.718,322.674,98.264,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6473"
    },
    d: "M332,103.649c-9.327-5.385-6.022-28.569-0.637-37.896s17.311-12.522,26.638-7.138 s12.522,17.311,7.138,26.638C359.753,94.58,341.327,109.034,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F05467"
    },
    d: "M332,103.649c-9.327,5.385-6.022,28.569-0.637,37.896s17.311,12.522,26.638,7.138 s12.522-17.311,7.138-26.638C359.753,112.718,341.327,98.264,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F05467"
    },
    d: "M332,103.649c9.327-5.385,6.022-28.569,0.638-37.896c-5.385-9.327-17.311-12.522-26.638-7.138 s-12.522,17.311-7.138,26.638C304.248,94.58,322.674,109.034,332,103.649z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 332,
    cy: 103.649,
    r: 13
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D5F3D"
    },
    d: "M130.546,98c3.635,18.297,5.455,46,5.455,46s23.071,2.249,47-0.225c0-0.256,0-0.525,0-0.775 c0-15.386,1.7-30.476,4.981-45H130.546z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Girl);
export default __webpack_public_path__ + "static/media/002-girl.78eecf542619368b9323bd08c3cc0864.svg";
export { ForwardRef as ReactComponent };